/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const hourglass = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#hourglass_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M1 15h14M8 8c-2.546-.946-3.987-2.811-4.397-5.534a1.458 1.458 0 0 1 .03-.545c.044-.177.121-.34.226-.48.104-.14.234-.25.38-.327A.985.985 0 0 1 4.703 1M8 8c2.546-.946 3.987-2.811 4.397-5.534a1.456 1.456 0 0 0-.03-.545 1.341 1.341 0 0 0-.226-.48 1.134 1.134 0 0 0-.38-.327.985.985 0 0 0-.463-.114M8 8c-2.546.947-3.987 2.812-4.397 5.535-.024.181-.014.367.03.544.044.177.121.34.226.48.105.14.234.25.38.327a.986.986 0 0 0 .464.114M8 8c2.546.947 3.987 2.812 4.397 5.535.024.181.014.367-.03.544a1.37 1.37 0 0 1-.226.48c-.104.14-.234.25-.38.327a.986.986 0 0 1-.463.114M15 1H1"
      />
    </g>
    <defs>
      <clipPath id="hourglass_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default hourglass
